import { apiClient } from '@/api/client';
import { API_ENDPOINTS } from '@/api/endpoints';

/** USD-base live exchange rates served by the recommender. Prices are stored
 *  canonically in USD; the frontend multiplies by `rates[code]` to display in
 *  the user's chosen currency. `stale=true` means a fallback table is served
 *  because the live provider was unreachable. */
export type ExchangeRatesResponse = {
  base: string;
  rates: Record<string, number>;
  fetched_at: string;
  source: string;
  stale: boolean;
};

export const currencyService = {
  exchangeRates: () =>
    apiClient
      .get<ExchangeRatesResponse>(API_ENDPOINTS.CURRENCY.EXCHANGE_RATES)
      .then((r) => r.data),
};
